<div class="container mini-banner">
<div class="row-feedback">
  <div class="icone-banner">
    <i class="far fa-check-circle"></i>
  </div>
  <div class="texto-banner">
    <h3> {{ message | translate }}</h3>
  </div>
</div>
</div>
